import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=1f85f38b&"
import script from "./ClientSearch.vue?vue&type=script&lang=js&"
export * from "./ClientSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports